import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { PagedResult } from "src/app/admin/models/common/pagination";
import { SearchUserInputDto } from "src/app/admin/models/user-management-model";
import { BaseComponent } from "src/app/shared/base/base-component";
import {
  CreateUpdateReasonModel,
  ReasonModel,
  ReasonTypeEnum,
  SearchReasonInputDto,
} from "src/app/admin/models/reason-model";
import { CreateEditReasonComponent } from "../create-edit-reason/create-edit-reason.component";
import { ReasonService } from "src/app/admin/services/reason.service";
import { catchError, map } from "rxjs";

@Component({
  selector: "app-reason-list",
  templateUrl: "./reason-list.component.html",
  styleUrls: ["./reason-list.component.scss"],
})
export class ReasonListComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @ViewChild("dropdown") dropdown: NgbDropdown;
  active: number;
  isHideAddButton: boolean = false;
  public filterInputFocus: boolean = false;
  public pageSize: number = 10;
  public pageNumber: number = 1;

  public searchModel: SearchReasonInputDto;
  public gridView: PagedResult<ReasonModel>;
  constructor(private reasonsService: ReasonService) {
    super();
  }

  ngOnInit(): void {
    this.resetSearchModel();
    this.changeStatus();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  reloadGrid(event: any) {
    this.refreshData(event);
  }
  refreshData(searchModel: SearchReasonInputDto) {
    this.searchModel = searchModel;
    this.changeStatus();
  }
  refresh(page: number) {
    this.searchModel.pageNumber = page;
    this.changeStatus();
  }
  filterData(event: any) {
    this.refresh(1);
    this.toggleDropdown();
  }
  toggleDropdown() {
    if (this.dropdown.isOpen()) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }

  fetch() {
    const sub = this.reasonsService
      .GetAll(this.searchModel)
      .pipe(
        map((response: PagedResult<ReasonModel>) => {
          this.gridView = response;
        }),
        catchError((err) => {
          if (err.status === 403)
            this.showErrorMessage(err.error.error.message);
          else
            this.translate
              .get("ErrorCodes.RetrieveError")
              .subscribe((msg) => this.showErrorMessage(msg));

          return this.logException(err);
        })
      )
      .subscribe();
    this.subscription.push(sub);
  }
  create(): void {
    const modalRef = this.modalService.open(CreateEditReasonComponent, {
      size: "xs",
    });
    let model: CreateUpdateReasonModel = {
      id: 0,
      description: "",
      reasonTypeId: this.searchModel.reasonTypeId,
    };
    modalRef.componentInstance.reason = model;
    modalRef.result.then(
      (res) => this.refresh(1),
      () => {}
    );
  }
  private resetSearchModel() {
    this.gridView = {} as PagedResult<ReasonModel>;
    this.gridView.items = [];
    this.gridView.totalCount = 0;
    this.gridView.pageNumber = this.pageNumber;
    this.gridView.pageSize = this.pageSize;

    this.searchModel = {} as SearchReasonInputDto;
    this.searchModel.pageSize = this.pageSize;
    this.searchModel.pageNumber = this.pageNumber;
  }
  GetActiveTab() {
    let value = sessionStorage.getItem("reasonactiveTab");
    this.active = value !== null ? parseInt(value) : 1;
  }
  SetActiveTab(val: number) {
    sessionStorage.setItem("reasonactiveTab", val.toString());
  }
  changeStatus(reset: boolean = false) {
    if (reset) this.resetSearchModel();
    this.GetActiveTab();
    switch (this.active) {
      case 2:
        this.searchModel.reasonTypeId = ReasonTypeEnum.Suspended;
        this.isHideAddButton = true;
        break;
      case 3:
        this.searchModel.reasonTypeId = ReasonTypeEnum.Cancelled;
        this.isHideAddButton = true;
        break;
      default:
        this.searchModel.reasonTypeId = null;
        this.isHideAddButton = false;
    }
    this.fetch();
  }
}
